import React from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import AppliedForm from './AppliedForm';
import { dateHelpers } from '../../../../../../helpers';

export const JobApplicationsExternalSingle = (props) => {

    const {
        application,
    } = props;

    const todaysDate = new Date().getTime();

    return (
        <div className="table__row manage-jobs-item">
            <div className="manage-jobs-item__summary">
                <div className="row">
                    <div className="col-xs-12 col-lg-4">
                        <div className="main__name">
                            <Link to={`/jobs/${application.id}`}>{application.title}</Link>
                        </div>
                        <div className="main__salary">
                            {application.salary}
                        </div>
                    </div>
                    <div className="col-xs-6 col-lg-2 col--date">
                        <span className="main__date">
                            {
                                (new Date(application.end_date)).getTime() > todaysDate ?
                                    <span className="main__date">
                                        <span className="date__label">Expires </span>
                                        <span className="date__info">{ dateHelpers.dateConverter( application.end_date ) }</span>
                                    </span>
                                    :
                                    <span className="main__date--expired">
                                        <span className="date__label"><i className="fa fa-exclamation-triangle" /> Expired </span>
                                        <span className="date__info">{ dateHelpers.dateConverter( application.end_date ) }</span>
                                    </span>
                            }
                        </span>
                    </div>
                    <div className="col-xs-12 col-lg-6 col--status">
                        <AppliedForm
                            key={application.id}
                            job_id={application.id}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

JobApplicationsExternalSingle.propTypes = {
    application: PropTypes.object
};


// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobApplicationsExternalSingle.js